import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=5dcf0df3&scoped=true&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=5dcf0df3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf0df3",
  null
  
)

export default component.exports